import React from 'react'
import { Helmet } from 'react-helmet-async'
import { DownloadsLayout } from '../../layouts'

const DownloadsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Media library downloads</title>
      <meta name="description" content="Downloads page" />
    </Helmet>
    <DownloadsLayout />
  </React.Fragment>
)

export default DownloadsPage
